<template>
  <div class="form-group">
    <label class="form-label">Номер договора страхования</label>
    <input name="contractNumber" type="text" class="form-text" v-model="contractNumber">
  </div>

  <InputWithLabel
      type="date"
      name="contractDate"
      placeholder="дд.мм.гггг"
      max="2100-12-31"
      :errors="v$.contractDate.$errors"
      v-model="contractDate"
      @blur="v$.contractDate.$touch"
      scroll-into-view-if-errors
  >
    Дата заключения договора страхования*
  </InputWithLabel>

  <InputWithLabel
      type="text"
      name="lastName"
      :errors="v$.lastName.$errors"
      v-model="lastName"
      @blur="v$.lastName.$touch"
      scroll-into-view-if-errors
  >
    Фамилия заявителя*
  </InputWithLabel>

  <InputWithLabel
      type="text"
      name="name"
      :errors="v$.name.$errors"
      v-model="name"
      @blur="v$.name.$touch"
      scroll-into-view-if-errors
  >
    Имя заявителя*
  </InputWithLabel>

  <InputWithLabel
      type="text"
      name="patronymic"
      :errors="v$.patronymic.$errors"
      v-model="patronymic"
      @blur="v$.patronymic.$touch"
      :hints="['Если отчество отсутствует, то укажите \'Нет\'.']"
      scroll-into-view-if-errors
  >
    Отчество заявителя*
  </InputWithLabel>

  <div class="form-group">
    <label class="form-label">Заявителем является*</label>
    <CustomSelect name="applicant" @initialize="onPersonTypeSelectInitialize" @itemSelected="onPersonTypeSelectItemSelected">
      <option value="InsuredPerson">Страхователь</option>
      <option value="AnotherPersonInsurer">Иное лицо</option>
    </CustomSelect>
  </div>

  <component :is="applicantPersonType"></component>
</template>

<script>
import * as mns from "@/store/mutation-types";
import {mapGetters} from "vuex";
import InsuredPerson from "@/components/insurances/persons/InsuredPerson";
import AnotherPersonInsurer from "@/components/insurances/persons/AnotherPersonInsurer";
import useVuelidate from "@vuelidate/core";
import {required, helpers} from "@vuelidate/validators";
import {dateGreaterThan, dateLessThenCurrent, dateRequired} from "@/validators/date-validators";
import InputWithLabel from "@/components/utils/InputWithLabel";
import CustomSelect from "@/components/utils/CustomSelect";

export default {
  anotherNameLife: "ContractInfoApplicant",
  components: {InputWithLabel, CustomSelect, InsuredPerson, AnotherPersonInsurer},
  data(){
    return {
      v$: useVuelidate(),
    }
  },
  validations(){
    return {
      contractDate: {
        dateLessThenCurrent: helpers.withMessage('Дата не может быть больше, чем текущая', dateLessThenCurrent),
        dateGreaterThan: helpers.withMessage('Дата не может быть меньше 1900 года.', dateGreaterThan(1900, 1, 1)),
        dateRequired: helpers.withMessage('Поле должно быть заполнено', dateRequired)
      },
      lastName: {
        required: helpers.withMessage('Поле должно быть заполнено', required)

      },
      name: {
        required: helpers.withMessage('Поле должно быть заполнено', required)

      },
      patronymic: {
        required: helpers.withMessage('Поле должно быть заполнено', required)
      }
    }
  },
  methods: {
    onPersonTypeSelectInitialize(event){
      this.$store.commit(mns.SET_APPLICANT_PERSON_TYPE, event.getValue().value);
    },
    onPersonTypeSelectItemSelected(event){
      this.$store.commit(mns.SET_APPLICANT_PERSON_TYPE, event.detail.choice.value);
    },
  },
  computed: {
    ...mapGetters(['applicantPersonType']),
    contractNumber:{
      get(){
        return this.$store.getters.contractNumber;
      },
      set(value){
        this.$store.commit(mns.SET_CONTRACT_NUMBER, value);
      }
    },
    contractDate:{
      get(){
        return this.$store.getters.contractDate;
      },
      set(value){
        this.$store.commit(mns.SET_CONTRACT_DATE, value);
      }
    },
    lastName:{
      get(){
        return this.$store.getters.lastName;
      },
      set(value){
        this.$store.commit(mns.SET_LAST_NAME, value);
      }
    },
    name:{
      get(){
        return this.$store.getters.name;
      },
      set(value){
        this.$store.commit(mns.SET_NAME, value);
      }
    },
    patronymic:{
      get(){
        return this.$store.getters.patronymic;
      },
      set(value){
        this.$store.commit(mns.SET_PATRONYMIC, value);
      }
    },
  },
}
</script>

<style scoped>

</style>